import type { FC } from "react";
import { tv } from "tailwind-variants";
import { Size } from "../helpers/helpers.js";

export interface PillSkeletonProps {
  size: Size;
}

const pillSkeleton = tv({
  base: "inline-block animate-pulse rounded-md bg-gray-300",
  variants: {
    size: {
      [Size.SMALL]: "h-6 w-14",
      [Size.MEDIUM]: "h-9 w-16",
      [Size.LARGE]: "h-11 w-20",
    },
  },
});

export const PillSkeleton: FC<PillSkeletonProps> = (props) => {
  return <div className={pillSkeleton({ size: props.size })}>&nbsp;</div>;
};
